import { randomNumber } from '../../../../utilities'
import { DrainConstants } from './drain.constants'
import { IDrainState, IDrainAction } from './drain.types'

export const initialDrainState: IDrainState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  assessedBy: null,
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  action: null,
  procedure: null,
  size: '',
  field2: null,
  sizeUnit: null,
  drainSuction: null,
  chestSuction: null,
  foleyColor: null,
  csfColor: null,
  capped: null,
  side: null,
  location: null,
  intercostalSpace: null,
  depth: '',
  updateInputRows: false,
  type: 'Drain',
  addToTimeline: false,
  chestSuctionHiddenFlag: false,
  csfColorHiddenFlag: false,
  depthHiddenFlag: false,
  drainSuctionHiddenFlag: false,
  foleyColorHiddenFlag: false,
  procedureHiddenFlag: false,
  sideHiddenFlag: false,
  sizeHiddenFlag: false,
  sizeUnitHiddenFlag: false,
  isEkgImport: null,
  drainDefaults: null,
  nemsisCode: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
}

export function drainReducer(state: IDrainState = initialDrainState, action: IDrainAction): IDrainState {
  switch (action.type) {
    case DrainConstants.SET_KEY:
      return { ...state, key: action.key }
    case DrainConstants.SET_FIELD2:
      return { ...state, field2: action.field2 }
    case DrainConstants.SET_DATE:
      return { ...state, date: action.date }
    case DrainConstants.SET_TIME:
      return { ...state, time: action.time }
    case DrainConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case DrainConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case DrainConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case DrainConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case DrainConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case DrainConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case DrainConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case DrainConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case DrainConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case DrainConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case DrainConstants.SET_STATE:
      return { ...action.drainState, updateInputRows: true }
    case DrainConstants.SET_TYPE:
      return { ...state, type: action.type }
    case DrainConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case DrainConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case DrainConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case DrainConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case DrainConstants.SET_ACTION:
      return { ...state, action: action.action }
    case DrainConstants.SET_PROCEDURE:
      return { ...state, procedure: action.procedure }
    case DrainConstants.SET_SIZE:
      return { ...state, size: action.size }
    case DrainConstants.SET_SIZE_UNIT:
      return { ...state, sizeUnit: action.sizeUnit }
    case DrainConstants.SET_DRAIN_SUCTION:
      return { ...state, drainSuction: action.drainSuction }
    case DrainConstants.SET_CHEST_SUCTION:
      return { ...state, chestSuction: action.chestSuction }
    case DrainConstants.SET_FOLEY_COLOR:
      return { ...state, foleyColor: action.foleyColor }
    case DrainConstants.SET_CSF_COLOR:
      return { ...state, csfColor: action.csfColor }
    case DrainConstants.SET_CAPPED:
      return { ...state, capped: action.capped }
    case DrainConstants.SET_SIDE:
      return { ...state, side: action.side }
    case DrainConstants.SET_LOCATION:
      return { ...state, location: action.location }
    case DrainConstants.SET_INTERCOSTAL_SPACE:
      return { ...state, intercostalSpace: action.intercostalSpace }
    case DrainConstants.SET_DEPTH:
      return { ...state, depth: action.depth }
    case DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case DrainConstants.SET_DRAIN_DEFAULTS:
      return { ...state, drainDefaults: action.drainDefaults }
    case DrainConstants.RESET_TO_INITIAL_STATE:
      return {
        ...state,
        procedure: null,
        size: '',
        sizeUnit: null,
        drainSuction: null,
        chestSuction: null,
        foleyColor: null,
        csfColor: null,
        side: null,
        location: null,
        intercostalSpace: null,
        depth: '',
        field2: null,
        capped: null,
      }
    case DrainConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        assessedBy: null,
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        action: null,
        procedure: null,
        size: '',
        sizeUnit: null,
        drainSuction: null,
        chestSuction: null,
        foleyColor: null,
        csfColor: null,
        capped: null,
        side: null,
        location: null,
        intercostalSpace: null,
        field2: null,
        depth: '',
        updateInputRows: false,
        type: 'Drain',
        addToTimeline: false,
        chestSuctionHiddenFlag: false,
        csfColorHiddenFlag: false,
        depthHiddenFlag: false,
        drainSuctionHiddenFlag: false,
        foleyColorHiddenFlag: false,
        procedureHiddenFlag: false,
        sideHiddenFlag: false,
        sizeHiddenFlag: false,
        sizeUnitHiddenFlag: false,
        isEkgImport: null,
        drainDefaults: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
